<template>
  <div data-v-6cacbbb1="" class="contents">
    <nav data-v-6cacbbb1="" class="nav_mobile_top">
      <div data-v-6cacbbb1="" class="nav_content">
        <div data-v-6cacbbb1="" class="nav_left nav_left1">
          <div data-v-6cacbbb1="" class="back" @click="$router.go(-1)">
            <img
              data-v-6cacbbb1=""
              src="../../assets/img/arrow_back.d5eef796-0de7d3ca.svg"
              alt=""
            />
          </div>
          <div data-v-6cacbbb1="" class="nav_name2">{{ $t('commomwd') }}</div>
          <div data-v-6cacbbb1="" class="start"></div>
        </div>
      </div>
    </nav>
    <div data-v-6cacbbb1="" class="empty-box"></div>
    <div data-v-6cacbbb1="" class="contents-box" style="padding: 0px 20px">
      <div data-v-6cacbbb1="" class="content-list" v-for="item in list">
        <!---->
        <div data-v-6cacbbb1="" class="title" v-if="lang === 'zh'">
          {{ item.zh_cn_title }}
        </div>
        <div data-v-6cacbbb1="" class="title" v-if="lang === 'tw'">
          {{ item.zh_tw_title }}
        </div>
        <div data-v-6cacbbb1="" class="title" v-if="lang === 'en'">
          {{ item.en_title }}
        </div>
        <div data-v-6cacbbb1="" class="title" v-if="lang === 'jp'">
          {{ item.jp_title }}
        </div>
        <div data-v-6cacbbb1="" class="title" v-if="lang === 'ko'">
          {{ item.ko_title }}
        </div>
        <div data-v-6cacbbb1="" class="icons">
          <img
            data-v-6cacbbb1=""
            src="../../assets/img/add.7320c919-7cee0a0a.svg"
            class=""
            v-if="!shoumore"
            @click="shoumore = true"
          /><img
            data-v-6cacbbb1=""
            src="../../assets/img/minus.cc2e8373-deb9dbea.svg"
            class="symbol"
            v-else
            @click="shoumore = false"
          />
        </div>
        <div data-v-6cacbbb1="" class="info">
          <div data-v-6cacbbb1="" v-if="lang === 'zh'">
            <p data-v-6cacbbb1="" v-html="item.zh_cn_contents"></p>
          </div>
          <div data-v-6cacbbb1="" v-if="lang === 'tw'">
            <p data-v-6cacbbb1="" v-html="item.zh_tw_contents"></p>
          </div>
          <div data-v-6cacbbb1="" v-if="lang === 'en'">
            <p data-v-6cacbbb1="" v-html="item.zh_en_contents"></p>
          </div>
          <div data-v-6cacbbb1="" v-if="lang === 'jp'">
            <p data-v-6cacbbb1="" v-html="item.jp_contents"></p>
          </div>
          <div data-v-6cacbbb1="" v-if="lang === 'ko'">
            <p data-v-6cacbbb1="" v-html="item.ko_contents"></p>
          </div>
        </div>
      </div>

      <div data-v-6cacbbb1="" class="empty-box" style="height: 80px"></div>
    </div>
    <div data-v-6cacbbb1="" class="loadingbox" style="display: none"></div>
  </div>
</template>
<script>
import '../../assets/css/index-c925edae.css'
import '../../assets/css/514.cbfba8eb.css'
export default {
  data() {
    return {
      list: [],
      shoumore: false,
      lang: localStorage.getItem('lang') || 'zh',
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    async getlist() {
      const { data } = await this.$http.post('/getallfaq')
      if (data) {
        this.list = data.data
      }
    },
  },
}
</script>
<style scoped lang="less"></style>
